import { render } from "./Bulk.vue?vue&type=template&id=2274ed84&scoped=true"
import script from "./Bulk.vue?vue&type=script&lang=js"
export * from "./Bulk.vue?vue&type=script&lang=js"

import "./Bulk.vue?vue&type=style&index=0&id=2274ed84&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2274ed84"]])

export default __exports__